import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { getContentPage } from '../api/catalog'
import type { CatalogPage } from '../api/types'
import Loading from '../components/Loading'

export default function ContentPage({ template }: { template: string }) {
  const [page, setPage] = useState<CatalogPage | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setPage(null)
    getContentPage(template)
      .then((res) => setPage(res.page))
      .catch((err: Error) => setError(err.message))
  }, [template])

  if (error) return <p className="error container section">{error}</p>
  if (!page) return <Loading />

  return (
    <div className="container section content-page">
      <Helmet>
        <title>{page.seo.title ?? page.title ?? 'Helmach'}</title>
        {page.seo.description && <meta name="description" content={page.seo.description} />}
      </Helmet>

      <h1>{page.title}</h1>
      {page.image && <img src={page.image} alt={page.title ?? ''} />}
      {page.content && <div dangerouslySetInnerHTML={{ __html: page.content }} />}
    </div>
  )
}
